import { useEffect, useState } from 'react';

export default function InputText({
  label,
  inputId,
  placeholder,
  value = '',
  setValue = '',
  required = false,
  isValid,
  setIsValid = () => {},
  inputMode = 'text',
  customType,
  showErrors = false,
}) {
  const [validText, setValidText] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const hasValue = typeof value === 'string' ? Boolean(value.trim()) : Boolean(value);
    if (required && !hasValue && inputId !== 'shipmentCost') {
      setValidText('필수 입력값입니다.');
      setIsValid(false);
      return;
    }

    setValidText('');
    setIsValid(true);
  }, [inputId, required, setIsValid, value]);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-[minmax(160px,1fr)_minmax(0,3fr)_minmax(160px,1fr)] gap-2 md:gap-4 items-center mb-2">
      <label htmlFor={inputId} className="text-explorer font-semibold text-base">
        {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
      </label>
      <input
        id={inputId}
        type="text"
        inputMode={inputMode}
        placeholder={placeholder}
        className="min-w-0 w-full rounded-lg py-1 px-3"
        value={value}
        onBlur={() => setTouched(true)}
        onChange={async (e) => {
          const textValue = customType === 'price' ? e.target.value.trim() : e.target.value;

          if (customType === 'price' && Number.isNaN(+textValue)) {
            return alert('가격은 숫자만 입력 가능합니다. 숫자만 입력해주세요.');
          }

          setValue(textValue);

          if (textValue.trim()) {
            return setIsValid(true);
          }

          setIsValid(false);
        }}
      />
      <span className="text-red-400 text-sm">{(touched || showErrors) ? validText : ''}</span>
    </div>
  );
}
